// extracted by mini-css-extract-plugin
export default {"list":"Lk5mrz","item":"vD0k6e","link":"zIRafg","icon":"dA894N","linkStateActive":"B71LOT","counter":"OnNGrX","indicator":"WUNPAU"};